<template>
  <div>
    <ModalGlobal id="logoutModal" v-if="modalRecover">
      <template #dialogHeadImg>
        <img
          class="
            absolute
            h-22
            -top-12
            left-0
            right-0
            m-auto
            pointer-events-none
          "
          :src="$S3AssetUrl('suf/photopass-logo.png')"
          alt="logo photo"
        />
      </template>

      <template #dialogHeading>{{ $t('Forms.title_modal_recover') }}</template>

      <template #dialogDescription>{{ $t('Forms.msg_modal_recover') }}</template>

      <router-link
        :title="$t('Forms.login_account')"
        class="
          w-full
          flex
          justify-center
          rounded-full
          py-3
          px-4
          mb-4
          bg-yellow-photo
          cursor-pointer
          font-semibold
          mx-auto
        "
        :to="{ name: 'login' }"
        >{{ $t('Forms.login_account') }}</router-link
      >

      <button
        @click="modalRecover = false"
        :disabled="loading"
        type="button"
        class="
          w-full
          flex
          justify-center
          rounded-full
          py-3
          px-4
          mb-1
          border-yellow-photo border
          bg-white
          cursor-pointer
          font-semibold
          mx-auto
        "
      >
        Continuar navegando
      </button>
    </ModalGlobal>

    <div class="mb-8"></div>
    <section class="flex flex-col-reverse md:flex-row container mx-auto">
      <!-- Image -->
      <div class="flex w-full md:w-3/5 items-center mx-auto">
        <img
          alt="logo"
          class="w-full"
          :src="$S3AssetUrl('suf/profile/register-user.jpg')"
        />
      </div>

      <!-- Forgot Form | Recovery Account -->
      <div class="flex flex-col w-full md:w-2/5 mx-auto px-4">
        <h2 class="py-2 text-2xl font-bold">¡Recupera tu cuenta!</h2>
        <p class="mb-4">
          Por favor ingresa una nueva contraseña, esta debe contener más de 8
          caracteres, al menos 1 letra mayuscula , 1 letra minuscula, 1 número,
          1 caracter especial.
        </p>

        <p class="py-3">
          {{ $t('Forms.if_you_have_account') }}
          <router-link
            :to="{ name: 'login' }"
            class="cursor-pointer text-newxcaret-blue"
          >
            {{ $t('Forms.login') }}
          </router-link>
        </p>

        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            @submit.prevent="handleSubmit(activateUserAccountCreated)"
            class="flex flex-col w-full pt-2 pb-6 relative"
          >
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <label class="font-bold" :for="$t('Forms.email')">{{
                $t('Forms.email')
              }}</label>
              <input
                type="text"
                placeholder="email@dominio.com"
                :id="$t('Forms.email')"
                v-model="formResetPassword.Email"
                :class="[errors.length && 'border-newxcaret-red']"
                class="
                  w-full
                  h-10
                  p-3
                  my-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                "
              />
              <p class="txt-error text-red text-xs italic mb-4">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
            <p class="txt-error text-red text-xs italic" v-if="errorLogin.email">
              {{ responseErrors.Email[0] }}
            </p>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
              <label class="font-bold" :for="$t('Forms.code')">{{
                $t('Forms.code_email')
              }}</label>
              <input
                type="text"
                :id="$t('Forms.code')"
                :name="$t('Forms.code')"
                v-model="formResetPassword.Code"
                :class="[errors.length && 'border-newxcaret-red']"
                class="
                  w-full
                  h-10
                  p-3
                  my-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                "
              />
              <p class="txt-error text-red text-xs italic mb-4">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
            <p class="txt-error text-red text-xs italic" v-if="errorLogin.Code">
              {{ responseErrors.Code[0] }}
            </p>

            <div class="flex -mx-2">
              <div class="w-1/2 mx-2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  vid="confirmation"
                >
                <!-- {{errors}} -->
                  <label class="font-bold" :for="$t('Forms.new_password')">{{
                    $t('Forms.new_password')
                  }}</label>
                  <input
                    type="password"
                    :id="$t('Forms.new_password')"
                    v-model="formResetPassword.Password"
                    :class="[errors.length && 'border-newxcaret-red']"
                    @keyup="validatePassword($event.target.value)"
                    class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                      text-grey
                    "
                  />
                  <p class="txt-error text-red text-xs italic mb-4">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <ValidationProvider
                  rules="required|confirmed:confirmation"
                  v-slot="{ errors }"
                >
                  <label
                    class="font-bold"
                    :for="$t('Forms.confirmation_password')"
                    >{{ $t('Forms.confirmation_password') }}</label
                  >
                  <input
                    type="password"
                    v-model="formResetPassword.ConfirmationPassword"
                    :id="$t('Forms.confirmation_password')"
                    :name="$t('Forms.confirmation_password')"
                    :class="[errors.length && 'border-newxcaret-red']"
                    class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                      text-grey
                    "
                  />
                  <p class="txt-error text-red text-xs italic">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>

              <div class="w-1/2 text-xs mx-2" v-if="errorLogin.password">
                <p>Tu contraseña debe tener:</p>
                <ul class="list-disc ml-4">
                  <li
                    v-for="(item, index) in responseErrors.Password"
                    :key="index"
                  >
                    {{ item.msg }}
                  </li>
                </ul>
              </div>
            </div>

            <p class="txt-error text-red text-xs italic" v-if="msgApi.error">
              {{ msgApi.message }}
            </p>

            <p class="txt-error text-red text-xs italic" v-if="msgApi.success">
              {{ msgApi.message }}
            </p>

            <button
              type="submit"
              class="
                flex
                items-center
                justify-center
                w-full
                mt-4 mt-4
                md:mx-2
                p-2
                bg-yellow-photo
                rounded-full
                text-sm
                font-semibold
              "
            >
              Actualizar
            </button>
          </form>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import "../validators/index";
import methodUser from "../mixins/methodUser";

import Users from "../mixins/Users";
import SearchPackage from "../photo/searchPackageComponent";
import loginData from "../logic/profile/login";
import registerData from "../logic/profile/register";
import activateNewUserData from "../logic/profile/activateNewUser";
import recoveryPasswordData from "../logic/profile/recoveryPassword";
import validatePasswordData from "../logic/profile/validatePassword";

// import todos from "@/l"
// axios.defaults.withCredentials = true;

export default {
  props: [],
  mixins: [methodUser, Users],
  components: {
    SearchPackage
  },
  data: () => ({
    modalRecover: false,
    user: {},
    pathname: window.location.origin + "/",
    BirthdateInput: { name: "Birthdate" },
    loading: false,
    formLogin: {
      Username: "",
      Password: "",
    },
    formRegister: {
      Password: "", //*
      Email: "", //example@email.com
      FirstName: "", //test
      LastName: "", //test
      Phone: "",
      Birthdate: "", //31/12/1982
      Locale: "", //Mexico
      Gender: "", //Masculino
      Title: "", //Sr.
    },
    formActiveNewUser: {
      Email: "", //example@email.com
      Code: "",
      helperBtnSend: true,
    },
    formResetPassword: {
      Email: "", //example@email.com
      Code: "",
      Password: "",
      ConfirmationPassword: "",
      helperBtnSend: true,
    },
    formRecoveryPass: {
      Email: "",
    },
  }),
  watch: {
    activeForm: function () {
      this.errorLogin.statusApiMessage = false;
      this.msgApi.success = false;
      this.msgApi.error = false;
      this.disableAllInputs();
    },
  },
  methods: {
    async login() {
      try {
        this.loading = true;
        // POST request using axios
        let response = await loginData.get(this.formLogin);

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error de validacion de campos
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(([key, value]) => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.username = false;
          this.errorLogin.password = false;
          if (this.errorFormInput(response.data, "ACCESS")) {
            this.activeForm = response.data.ACCESS == true ? 3 : 0;
            this.setUserLoggedIn(response.data.ACCESS == true ? true : false);
          } else {
            if (
              this.errorFormInput(response.data, "SUCCESS") &&
              this.errorFormInput(response.data, "MESSAGE")
            ) {
              if (response.data.SUCCESS == "false") {
                this.msgApi.error = true;
                this.msgApi.message = response.data.MESSAGE;
              }
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async register() {
      try {
        // POST request using axios
        let response = await registerData.create(this.formRegister);
        this.loading = true;
        this.errorLogin.statusApiMessage = false;

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(([key, value]) => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          this.errorLogin.password = false;
          this.errorLogin.birthdate = false;

          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (this.errorFormInput(response.data, "SUCCESS")) {
              if (response.data.SUCCESS == "true") {
                this.msgApi.error = false;
                this.msgApi.success = true;
                this.activeForm = 4;
                this.formActiveNewUser.Email = this.formRegister.Email;
              } else {
                this.msgApi.error = false;
                this.msgApi.error = true;
              }
              this.msgApi.message = response.data.MESSAGE;
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        //se settea el loadign para desaactivarlo
        this.loading = false;
        
      }
    },
    async activateNewUser() {
      try {
        this.loading = true;
        this.errorLogin.statusApiMessage = false;
        // POST request using axios
        let response = await activateNewUserData.create(this.formActiveNewUser);

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(([key, value]) => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          this.errorLogin.Code = false;

          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (this.errorFormInput(response.data, "SUCCESS")) {
              if (response.data.SUCCESS == "true") {
                this.msgApi.error = false;
                this.msgApi.success = true;

                this.activeForm = 0;

                this.makeToast("success", "¡Tu cuenta ha sido activada!");
              } else {
                this.msgApi.success = false;
                this.msgApi.error = true;
              }
              this.msgApi.message = response.data.MESSAGE;
              
              
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        //se settea el loadign para desaactivarlo
        this.loading = false;
        
      }
    },
    async recoveryPassword() {
      try {
        // POST request using axios
        let response = await recoveryPasswordData.create(this.formRecoveryPass);
        this.loading = true;
        this.errorLogin.statusApiMessage = false;

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(([key, value]) => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (response.data.SUCCESS == "true") {
              this.msgApi.error = false;
              this.msgApi.success = true;
              this.activeForm = 5;

              this.makeToast(
                "success",
                "¡Te enviamos un enlace a tu correo, para restablecer tu contraseña!"
              );
            } else {
              this.msgApi.error = false;
              this.msgApi.error = true;
            }
            this.msgApi.message = response.data.MESSAGE;
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        
        //se settea el loadign para desaactivarlo
        this.loading = false;
      }
    },
    async validatePassword(valuePassword) {
      try {
        // POST request using axios
        let response = await validatePasswordData.get({
          Password: valuePassword,
        });
        this.formActiveNewUser.helperBtnSend = true;
        this.responseErrors = response.data;

        Object.entries(this.responseErrors).forEach(([key, value]) => {
          this.validFieldsRegister(this.responseErrors);
        });

        if (!response.data.count) {
          this.errorLogin.password = false;
          this.formActiveNewUser.helperBtnSend = false;
          this.formResetPassword.helperBtnSend = false;
        } else {
          this.errorLogin.password = true;
          this.formActiveNewUser.helperBtnSend = true;
          this.formResetPassword.helperBtnSend = true;
        }
      } catch (error) {
        
      }
    },
  },
  mounted() {},
};
</script>